"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteHeaderGap = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _navigationUtils = require("../../utils/navigationUtils");

var _user = require("../../redux/modules/user");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SiteHeaderContainer = function (_React$Component) {
  (0, _inherits3.default)(SiteHeaderContainer, _React$Component);

  function SiteHeaderContainer(props) {
    (0, _classCallCheck3.default)(this, SiteHeaderContainer);
    return (0, _possibleConstructorReturn3.default)(this, (SiteHeaderContainer.__proto__ || (0, _getPrototypeOf2.default)(SiteHeaderContainer)).call(this, props));
  }

  (0, _createClass3.default)(SiteHeaderContainer, [{
    key: "componentDidMount",
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _props, authLoggedIn, userLoaded, dispatch;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _navigationUtils.loadNavigationWF)();

              case 2:
                if (!customElements.get("quixel-navigation")) {
                  console.warn("[SiteHeaderContainer] quixel-navigation loading issue");
                }

                // Defensive check: if auth is loaded but user isn't, load user data
                // This handles the race condition where router renders before user data loads
                _props = this.props, authLoggedIn = _props.authLoggedIn, userLoaded = _props.userLoaded, dispatch = _props.dispatch;

                console.log("[SiteHeaderContainer] componentDidMount - authLoggedIn:", authLoggedIn, "userLoaded:", userLoaded);
                if (authLoggedIn && !userLoaded) {
                  console.log("[SiteHeaderContainer] Auth loaded but user not loaded, loading user data...");
                  dispatch((0, _user.load)());
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Check whenever auth or user state changes
      var _props2 = this.props,
          authLoggedIn = _props2.authLoggedIn,
          userLoaded = _props2.userLoaded,
          dispatch = _props2.dispatch;


      console.log("[SiteHeaderContainer] componentDidUpdate - authLoggedIn:", authLoggedIn, "userLoaded:", userLoaded, "prev authLoggedIn:", prevProps.authLoggedIn, "prev userLoaded:", prevProps.userLoaded);

      // If auth just became true (Epic login completed), load user data
      if (authLoggedIn && !prevProps.authLoggedIn) {
        console.log("[SiteHeaderContainer] Auth just completed (Epic login), loading user data...");
        if (!userLoaded) {
          dispatch((0, _user.load)());
        }
      }

      // Also handle case where auth was already true but user wasn't loaded
      if (authLoggedIn && !userLoaded && prevProps.authLoggedIn && !prevProps.userLoaded) {
        console.log("[SiteHeaderContainer] Auth was true but user still not loaded, retrying...");
        dispatch((0, _user.load)());
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement("quixel-navigation", { locale: "en-US", isLoggedIn: this.props.loggedIn || false, displayName: this.props.maskedEmail, domain: _config2.default.apiBaseUrl });
    }
  }]);
  return SiteHeaderContainer;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    maskedEmail: state.auth.loggedIn && state.user.loaded && (0, _navigationUtils.maskEmail)(state.user.email) || "",
    loggedIn: state.auth.loggedIn && state.user.loaded,
    authLoggedIn: state.auth.loggedIn,
    userLoaded: state.user.loaded
  };
})(SiteHeaderContainer);
var SiteHeaderGap = exports.SiteHeaderGap = function SiteHeaderGap() {
  return _react2.default.createElement("div", { className: require("./SiteHeader.scss").SiteHeaderGap });
};


//////////////////
// WEBPACK FOOTER
// ./src/components/SiteHeader/SiteHeader.jsx
// module id = 2364
// module chunks = 0